import { connect } from 'react-redux';
import { openModal } from 'components/Modal';
import { PERMISSION } from 'constants/logic';
import { selectActiveVenue, selectUserHasPermission, selectClassSmartspotCanTurnOnOff } from 'selectors/general';
import { selectIsDesktop } from 'selectors/ui';
import ScheduleDetail from './ScheduleDetail';
import {
  selectActiveScheduleDetailTab,
  selectActiveScheduleId,
  selectActiveScheduleInsights,
  selectEnabledWaiverId,
  selectEnabledWaiverVersionId,
  selectRosterIsLoaded,
  selectScheduleInsightsHasError,
  selectScheduleInsightsIsLoaded,
} from './YieldManagement.selectors';
import {
  cancelSchedule,
  emailMember,
  emailScheduleAttendees,
  openCancelScheduleModal,
  setSelectedTab,
  updateReservationAttendance,
  updateScheduleReservationsNotStopped,
  updateScheduleReservationsStopped,
} from './YieldManagement.saga';
import { selectExcessInventoryShouldShow } from '../Stats/TabInsightsShared/InsightsTab.selectors';

const mapStateToProps = state => {
  const {
    currencyCode,
    directFillDataDisabled,
    isManualStudio,
    isReservationsStoppable,
    venueId,
    venueName,
    venueSubtitle,
    isMsInventoryVenue,
  } = selectActiveVenue(state);

  const rosterIsLoaded = selectRosterIsLoaded(state);
  const insightsIsLoaded = selectScheduleInsightsIsLoaded(state);
  const insightsHasError = selectScheduleInsightsHasError(state);
  const insights = selectActiveScheduleInsights(state);
  const canToggleClassSmartSpot = selectClassSmartspotCanTurnOnOff(state);
  const canManageClassSmartSpotOnOff = selectUserHasPermission(state, PERMISSION.CAN_SCHEDULE_SMARTSPOT_OFF);
  const canManageClassSmartSpotOnOffNR = selectUserHasPermission(state, PERMISSION.CAN_SCHEDULE_SMARTSPOT_OFF_NR);
  const shouldShowCancelRecurring = selectUserHasPermission(state, PERMISSION.CAN_CANCEL_ALL_FUTURE);
  const canViewRates = selectUserHasPermission(state, PERMISSION.DISPLAY_RATE);
  const cannotCancelClass = selectUserHasPermission(state, PERMISSION.REMOVE_CLASS_CANCEL);
  const tab = selectActiveScheduleDetailTab(state);
  const waiverId = selectEnabledWaiverId(state, venueId);
  const waiverVersionId = selectEnabledWaiverVersionId(state, venueId);
  const showExcessInventory = selectExcessInventoryShouldShow(state);

  return {
    rosterIsLoaded,
    insights,
    insightsIsLoaded,
    insightsHasError,
    cannotCancelClass,
    canToggleClassSmartSpot,
    canOnlyToggleNonRecurring: canManageClassSmartSpotOnOffNR && !canManageClassSmartSpotOnOff,
    canViewRates,
    noDirectFillData: isManualStudio || directFillDataDisabled,
    waiverId,
    waiverVersionId,
    venueId,
    venueName,
    venueSubtitle,
    currencyCode,
    tab,
    isReservationsStoppable,
    isDesktop: selectIsDesktop(state),
    isMsInventoryVenue,
    scheduleId: selectActiveScheduleId(state),
    shouldShowCancelRecurring,
    showExcessInventory,
  };
};

const mapDispatchToProps = {
  cancelSchedule,
  openModal,
  setSelectedTab,
  emailScheduleAttendees,
  emailMember,
  updateReservationAttendance,
  updateScheduleReservationsStopped,
  updateScheduleReservationsNotStopped,
  openCancelScheduleModal,
};

function mergeProps(stateProps, dispatchProps) {
  const { venueId, scheduleId } = stateProps;
  const {
    setSelectedTab: unboundSetSelectedTab,
    updateReservationAttendance: unboundUpdateReservationAttendance,
    updateScheduleReservationsStopped: unboundUpdateScheduleReservationsStopped,
    updateScheduleReservationsNotStopped: unboundUpdateScheduleReservationsNotStopped,
    ...restDispatchProps
  } = dispatchProps;

  return {
    ...stateProps,
    ...restDispatchProps,
    stopAllowingReservations: unboundUpdateScheduleReservationsStopped.bind(null, scheduleId),
    startAllowingReservations: unboundUpdateScheduleReservationsNotStopped.bind(null, scheduleId),
    updateReservationAttendance: unboundUpdateReservationAttendance.bind(null, scheduleId),
    setSelectedTab: unboundSetSelectedTab.bind(null, venueId, scheduleId),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ScheduleDetail);
